import React from 'react'
import { Link } from 'gatsby'
import { DesktopLogo, MobileLogo } from './'

const Logo = ({ animated, noPadding, wholeLogoMobile, route }) => {
	return (
		<Link to="/" className="flex--center">
			<div>
				<DesktopLogo />
				<MobileLogo />
				<style jsx>{`
					div {
						height: var(--nav-bar-height);
						width: 200px;
						display: flex;
						align-items: center;
						justify-content: center;
						top: 0;
						z-index: 103;
					}

					@media only screen and (max-width: 768px) {
						div {
							padding: 0;
							height: var(--nav-bar-height-mobile);
							width: 50px;
						}
					}
				`}</style>
			</div>
		</Link>
	)
}

export default Logo
